/**
 * How long the email step waits for checkExistingSubscription before it fails open.
 *
 * It was 5 s. For an email that already has an App Store / Google Play subscription the
 * server takes longer (RevenueCat refreshes the store data first): 7 of the 12 blocks from
 * 2026-09-25 to 10-25 took 4.7–6.4 s, so the buyer never saw "Welcome back" and 12 store
 * subscribers bought a second plan here with the same email (Linda twice). Emails without a
 * subscription answer in about 1 s (p90 1.2 s), so the longer wait costs only a real outage.
 */
export const CHECK_TIMEOUT_MS = 15000

/** The call's result, or `fallback` when it is slower than `ms` or fails. */
export async function withTimeout<T>(call: Promise<T>, ms: number, fallback: T): Promise<T> {
  let timer: ReturnType<typeof setTimeout> | undefined
  const timeout = new Promise<T>((resolve) => {
    timer = setTimeout(() => resolve(fallback), ms)
  })
  try {
    return await Promise.race([call.catch(() => fallback), timeout])
  } finally {
    clearTimeout(timer)
  }
}
